import * as THREE from 'three';
import { SVGLoader } from 'three/examples/jsm/loaders/SVGLoader';
import { Shell } from './shell';
import * as config from '../config.json';
import { CrucibleIdConfig } from '../config';
import { Vector3 } from 'three';

export class CrucibleIdText {
  public group: THREE.Group;
  protected _color: THREE.Color;
  protected _shell: Shell;
  protected _crucibleId: string;
  protected _config: CrucibleIdConfig;

  protected _fontURL: string;
  protected _svgloader: SVGLoader;
  protected _fontLoader: THREE.FontLoader;

  protected _radius: number;
  protected _size: number;
  protected _height: number;
  protected _angle: number;
  protected _speed: number;
  protected _range: number;
  protected _yOffset: number;

  constructor(crucibleId: string, parent: Shell, color: THREE.Color) {
    this.group = new THREE.Group();
    this.group.name = 'CrucibleIdText';
    this._svgloader = new SVGLoader();
    this._fontLoader = new THREE.FontLoader();

    this._crucibleId = crucibleId;
    this._color = color;
    this._shell = parent;

    this._config = config.crucibleId;
    this._fontURL = this._config.fontURL;
    this._radius = this._config.radius;
    this._size = this._config.size;
    this._height = this._config.height;
    this._speed = 0.05;

    this._angle = 0;
    this._range = 0.4;
    this._yOffset = 1;
  }

  // TODO: Separate load and add to scene so we only load the font once
  async loadAndAddToScene() {
    const font: THREE.Font = await this._fontLoader.loadAsync(this._fontURL);
    const characterCount: number = this._crucibleId.length;
    const angleInterval: number = (2 * Math.PI) / characterCount;

    let parentNode = new THREE.Object3D();
    this._shell.group.traverse((node) => {
      if (node.name === config.shell.glassNodeName) {
        parentNode = node;
      }
    });

    const material: THREE.Material = new THREE.MeshPhongMaterial({
      color: this._color,
      emissive: this._color,
      emissiveIntensity: 3
    });

    for (let i = 0; i < characterCount; i++) {
      let textGeometry: THREE.TextGeometry = new THREE.TextGeometry(
        this._crucibleId[i],
        {
          font: font,
          size: this._size,
          height: this._height,
          curveSegments: 5,
          bevelEnabled: true,
          bevelThickness: 0.1,
          bevelSize: 0.1,
          bevelSegments: 1
        }
      );

      textGeometry.center();

      let textMesh: THREE.Mesh = new THREE.Mesh(textGeometry, material);
      textMesh.position.set(
        Math.cos(angleInterval * i) * this._radius,
        this._yOffset,
        Math.sin(angleInterval * i) * this._radius
      );

      const position: Vector3 = new THREE.Vector3(0, 0, 0);
      parentNode.getWorldPosition(position);
      textMesh.lookAt(position);

      this.group.add(textMesh);
    }

    parentNode.add(this.group);
  }

  animate(timeElapsed: number) {
    this.group.rotation.y += this._speed * timeElapsed;
  }
}
